import { queryKeys } from "../queryKeys";
import { getAssets } from "../rest";
import type { Asset } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAssets = ({
  options,
}: {
  options?: QueryOptions<Asset[]>;
} = {}) => {
  const { data, refetch, isFetched } = useRequest(
    queryKeys.assets.list(),
    () => getAssets(),
    {
      gcTime: 9999999,
      staleTime: Infinity,
      ...options,
    },
  );

  return { assets: data || [], refetch, isFetched };
};

export default useGetAssets;
